import type { ApiToken } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export type ApiTokenView = WithId<Omit<ApiToken, 'tokenHash'>>;

export const apiTokenService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<ApiTokenView>> =>
    api.getPaginated<ApiTokenView>(withTenant('/api-tokens', tenantId, params)),

  /** Response carries the raw token (det_…) exactly once. */
  create: (
    tenantId: string,
    input: { name: string; expiresAt?: string }
  ): Promise<ApiTokenView & { token: string }> =>
    api.post(withTenant('/api-tokens', tenantId), input),

  remove: (tenantId: string, id: string): Promise<void> =>
    api.delete(withTenant(`/api-tokens/${id}`, tenantId)),
};
